
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';

import { useSchool } from '../../../context/SchoolContext';
import StaffFilters from '../components/StaffFilters';
import StaffStatsCards from '../components/StaffStatsCards';
import StaffTable from '../components/StaffTable';
import { staffApi } from '../services/staffApi';

const StaffListPage = () => {
  const navigate = useNavigate();
  const { schoolId, activeAcademicYearId } = useSchool();

  const [stats, setStats] = useState({
    totalStaff: 0,
    teachingStaff: 0,
    nonTeachingStaff: 0,
    classTeachers: 0,
  });

  const [query, setQuery] = useState('');
  const [staffType, setStaffType] = useState('');
  const [department, setDepartment] = useState('');
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);

  useEffect(() => {
    if (!schoolId) return undefined;

    let cancelled = false;

    const loadDashboardSummary = async () => {
      try {
        const response = await staffApi.getDashboardSummary(schoolId, { academicYearId: activeAcademicYearId });
        const summary = response?.data?.summary || response?.summary || {};

        if (!cancelled) {
          setStats({
            totalStaff: summary.total_staff ?? 0,
            teachingStaff: summary.teaching_staff ?? 0,
            nonTeachingStaff: summary.non_teaching_staff ?? 0,
            classTeachers: summary.class_teachers ?? 0,
          });
        }
      } catch (error) {
        console.error('Failed to load staff statistics.', error);
      }
    };

    loadDashboardSummary();

    return () => {
      cancelled = true;
    };
  }, [schoolId, activeAcademicYearId]);

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <h1 className="text-4xl font-bold text-slate-900">
            Staff / Teacher Management
          </h1>

          <p className="mt-2 text-gray-500">
            Manage teachers, staff profiles, login access, and assignments.
          </p>
        </div>

        <button
          type="button"
          onClick={() => navigate('/staff/add')}
          className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 font-medium text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          <Plus className="h-4 w-4" />
          Add Staff
        </button>
      </div>

      <StaffStatsCards stats={stats} />

      <StaffFilters
        query={query}
        staffType={staffType}
        department={department}
        status={status}
        onQueryChange={(value) => {
          setQuery(value);
          setPage(1);
        }}
        onStaffTypeChange={(value) => {
          setStaffType(value);
          setPage(1);
        }}
        onDepartmentChange={(value) => {
          setDepartment(value);
          setPage(1);
        }}
        onStatusChange={(value) => {
          setStatus(value);
          setPage(1);
        }}
      />

      <StaffTable
        filters={{
          q: query,
          staff_type: staffType,
          department,
          status,
        }}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
      />
    </div>
  );
};

export default StaffListPage;
